export interface FablabScanQrCodeTransactionInfo {
    trackingNumber: string;
    receiverEmails: string[];
}

export const MAX_FABLAB_SCAN_PAYLOAD_LENGTH = 65_536;

/**
 * Parse `trackingNumber;receiver1;receiver2;…` payloads.
 * Empty segments (e.g. trailing `;`) are dropped. Receiver emails are
 * de-duplicated case-insensitively while preserving first-seen order.
 */
export const parseFablabScanQrCodeTransactionInfo = (payload: string): FablabScanQrCodeTransactionInfo | null => {
    const parts = payload
        .split(';')
        .map((part) => part.trim())
        .filter((part) => part.length > 0);

    if (parts.length < 2) return null;

    const [trackingNumber, ...rawReceiverEmails] = parts;
    if (!trackingNumber || rawReceiverEmails.length === 0) return null;

    const seen = new Set<string>();
    const receiverEmails: string[] = [];

    for (const email of rawReceiverEmails) {
        const key = email.toLowerCase();
        if (seen.has(key)) continue;
        seen.add(key);
        receiverEmails.push(email);
    }

    if (receiverEmails.length === 0) return null;

    return { trackingNumber, receiverEmails };
};
